import PageComponent from '@gameday/common/components/form/Pages/Success'
import { useEffect } from 'react'

import commonStyles from 'shared/styles/common-styles.scss'

const PaymentCompletePage = props => {
  const { getFormSettings, formSettings, paymentStatus, getPaymentStatus } = props

  const urlParams = new URLSearchParams(window.location.search)

  const paymentIntent = urlParams.get('payment_intent')

  useEffect(() => {
    getFormSettings()
  }, [])

  useEffect(() => {
    if (!paymentIntent) {
      return
    }

    getPaymentStatus({ paymentIntent })
  }, [paymentIntent])

  if (!paymentStatus) {
    return null
  }

  const { amount, currency, metadata, paymentMethod } = paymentStatus
  const { description } = paymentMethod || {}

  const orderId = metadata.orderId || metadata['Orderer ID']
  const email = metadata.ordererEmail || metadata['Orderer Email']
  const firstName = metadata.ordererFirstname || metadata['Orderer First Name']

  return (
    <div className={commonStyles.splashPageContainer}>
      <div className={commonStyles.contentContainer}>
        <PageComponent
          paymentSuccessMessage={
            // biome-ignore lint/complexity/noUselessFragments: TODO
            <>
              <p>
                You will receive a copy of the payment receipt via email{' '}
                {email ? (
                  <span>
                    to <strong>{email}</strong>
                  </span>
                ) : (
                  'via email'
                )}
              </p>
            </>
          }
          successMessage={
            // biome-ignore lint/complexity/noUselessFragments: TODO
            <>
              <p>
                Your registration has been submitted. You will receive a copy of the payment receipt via email{' '}
                {email ? (
                  <span>
                    to <strong>{email}</strong>
                  </span>
                ) : (
                  'via email'
                )}
              </p>
            </>
          }
          formSettings={formSettings}
          formType={formSettings.formType}
          orderId={orderId}
          paymentData={{ total: { rawValue: amount, value: amount }, currencyCode: currency }}
          paymentMethod={{ type: 'Credit Card' }}
          paymentMethodDescription={description}
          user={{
            email,
            firstName,
          }}
          registrations={[]}
        />
      </div>
    </div>
  )
}

export default PaymentCompletePage
